module.exports = __webpack_public_path__ + "img/20211115.46ae5107.png";